var _path, _path2, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01_\u540E\u53F0\u673A\u6784\u7BA1\u7406") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,8V56H16V8H48m2-4H14a2,2,0,0,0-2,2V58a2,2,0,0,0,2,2H50a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54,56H10a2,2,0,1,0,0,4H54a2,2,0,0,0,0-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38,40.05v16H26v-16H38m2.17-4H23.83A1.82,1.82,0,0,0,22,37.88V58.23a1.81,1.81,0,0,0,1.82,1.82H40.18A1.82,1.82,0,0,0,42,58.23V37.88a1.83,1.83,0,0,0-1.83-1.83Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.01,
    y: 21.76,
    width: 16,
    height: 4,
    rx: 1.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.01,
    y: 21.76,
    width: 16,
    height: 4,
    rx: 1.79,
    transform: "translate(8.25 55.76) rotate(-90)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.7cf3f2aa.svg";
export { ForwardRef as ReactComponent };